export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    width: 110,
    slots: { default: 'opt' },
  },
  {
    type: 'expand',
    width: 75,
    align: 'center',
    title: that.$l('INDEX.table_label_expand') || '展开',
    slots: { content: 'expandContent' },
  },
  {
    field: 'defaultImageUrl',
    width: 120,
    title: that.$l('INDEX.table_label_image') || '图片',
    align: 'center',
    slots: { default: 'defaultImageUrl' },
  },
  {
    title: that.$l('INDEX.table_label_production_order_goods_no') || '产品编号',
    field: 'orderGoodsNo',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'string',
  },
  {
    title:
      that.$l('INDEX.table_label_production_order_identify_goods_no') ||
      '产品识别编号',
    field: 'identifyGoodsNo',
    minWidth: 250,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title:
      that.$l('INDEX.table_label_production_order_goods_name') || '产品名称',
    field: 'orderGoodsDisplayName',
    minWidth: 300,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title:
      that.$l('INDEX.table_label_production_order_goods_name_en') ||
      '产品英文名称',
    field: 'orderGoodsNameEn',
    minWidth: 200,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title:
      that.$l('INDEX.table_label_production_order_goods_master_category') ||
      '主分类',
    field: 'masterCategoryName',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title:
      that.$l('INDEX.table_label_production_order_goods_detail_category') ||
      '2级分类',
    field: 'categoryName',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_production_order_goods_qty') || '数量',
    field: 'qty',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'number',
  },
  {
    title:
      that.$l('INDEX.table_label_production_order_goods_is_group') ||
      '是否套装',
    field: 'v_isGroup',
    width: 80,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'isGroup' },
  },
  {
    title:
      that.$l('INDEX.table_label_production_order_goods_in_package_qty') ||
      '装箱入数',
    field: 'inPackageQty',
    width: 90,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'number',
  },
  {
    title:
      that.$l('INDEX.table_label_production_order_goods_box_qty') || '箱数',
    field: 'boxQty',
    width: 90,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'number',
  },
  {
    title:
      that.$l('INDEX.table_label_production_order_goods_price') || '成本价',
    field: 'v_price',
    width: 130,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'number',
  },
  {
    title:
      that.$l('INDEX.table_label_production_order_goods_amount') || '成本小计',
    field: 'v_subAmount',
    width: 200,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'number',
  },
]
